import React, { useEffect, useState } from "react";
import api from "../api";
import innerBanner from "../../assets/images/banner/inner-banner.jpg";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useFormattedNumbers from "../../hooks/useFormattedNumber";

const ScreenReader = () => {
  const { i18n, t } = useTranslation();
  const [screenReaderData, setScreenReaderData] = useState([]);
  const numbers = screenReaderData.map((_, index) => index + 1);
  const formattedNumbers = useFormattedNumbers(numbers);

  useEffect(() => {
    api
      .get(`/screen_reader?lang=${i18n.language}`)
      .then((response) => {
        setScreenReaderData(response.data);
      })
      .catch((error) => {
        console.error("Error fetching screen reader data:", error);
      });
  }, [i18n.language]);

  return (
    <>
      <section className="page-title">
        <div
          className="bg-layer"
          style={{
            backgroundImage: `url(${innerBanner})`,
          }}
        ></div>
        <div className="line-box">
          <div className="line-1"></div>
          <div className="line-2"></div>
        </div>
        <div className="auto-container">
          <div className="content-box">
            <h1>{t("screenReader.heading")}</h1>
            {/* Breadcrumb if needed */}
          </div>
        </div>
      </section>
      <div id="main-content">

        <br /> <br />

        <section className="service-style-four">
          <div className="auto-container">
            <h5 className="pb-4 fs-5 fw-none heading-margin">
              {t("screenReader.content")}
            </h5>
            <div className="table-responsive">
              <table className="table table-bordered">
                <thead className="text-center">
                  <tr>
                    <th style={{ backgroundColor: "#29aae1", color: "#fff" }}>
                      {t("srNo")}
                    </th>
                    <th style={{ backgroundColor: "#29aae1", color: "#fff" }}>
                      {t("screenReader.heading")}
                    </th>
                    <th style={{ backgroundColor: "#29aae1", color: "#fff" }}>
                      {t("screenReader.website")}
                    </th>
                    <th style={{ backgroundColor: "#29aae1", color: "#fff" }}>
                      {t("screenReader.commercial")}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {screenReaderData.length > 0 ? (
                    screenReaderData.map((item, index) => (
                      <tr key={item.id}>
                        <td>{formattedNumbers[index]}</td>
                        <td>{item.name}</td>
                        <td>
                          <Link
                            to={item.website}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{color:'black'}}
                          >
                            {item.website}
                          </Link>
                        </td>
                        <td>{item.available}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="text-center">
                        {t("noDataAvailable")}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default ScreenReader;
